import { Component, OnInit, Inject } from "@angular/core";
import { BV_DIALOG_DATA } from "../../design-system";
import { TournamentService } from "../../providers/tournament.service";
import { LoadingOverlayComponent } from "../loading-overlay/loading-overlay.component";
import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";

import { BvIconComponent } from "../../design-system/primitives/icon.component";
import { CloseDialogButtonComponent } from "../close-dialog-button/close-dialog-button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-player-moves",
    templateUrl: "./player-moves.component.html",
    styleUrls: ["./player-moves.component.scss"],
    imports: [LoadingOverlayComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvIconComponent, BvDialogFooterComponent, CloseDialogButtonComponent, TranslateModule]
})
export class PlayerMovesComponent implements OnInit {
  constructor(
    public tournServ: TournamentService,
    @Inject(BV_DIALOG_DATA) public data?: any
  ) {}

  get isBreaking(): boolean {
    return this.data && this.data.mode === "break";
  }

  ngOnInit() {}
}
